import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';
import axios from 'axios';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProgressBar from 'react-bootstrap/ProgressBar';

import './image.css';

export default class File extends React.Component {
	constructor(props) {
    super(props);
		this.state = {
			chatbox: props.channel,
			filename: '',
			percent: 0,
		};
		this.clickuploadFile = this.clickuploadFile.bind(this);
		this.uploadFile = this.uploadFile.bind(this);
	}

	async componentDidMount() {
	}

	componentWillUnmount() {
	}

	clickuploadFile() {
		document.getElementById('upload').click();
	}

	async uploadFile(event) {
		if( event.target.files[0] ) {
			this.setState({filename: event.target.files[0].name});
			const params = new FormData();
			params.append('file', event.target.files[0]);
			axios.put(`/api/v2/chatbox/${this.state.chatbox}/file`, params, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				withCredentials: true,
				onUploadProgress: (progressEvent) => {
					let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
					this.setState({percent: percentCompleted});
				}
			})
			.then(res => {
				console.log(res);
				switch(res.status) {
					case 200:
						this.props.complete();
						break;
					default:
						this.setState({filename: res.data.message, percent: 0});
						break;
				}
			})
		}
	}

	render() {
		return (
			<div className="upload-image">
				<Row onClick={this.clickuploadFile}>
					<Col xs={3} className="upload-file-outer">
						<div className="text-center upload-file-box">
							<div className="text-center upload-file-arrow">
								<button>
									<FontAwesomeIcon icon="cloud-arrow-up" />
								</button>

								<input id="upload" type="file" onChange={this.uploadFile} style={{display: 'none'}} />
							</div>
						</div>
					</Col>
					<Col>
						<div className="upload-file-info">
							<div className="float-right">
								{this.state.percent>0&&`${this.state.percent}%`}
							</div>
							<div className="">
								{this.state.filename.length>0?this.state.filename.substring(0,40):`Click to upload file`}
							</div>
							<div className="">
								<ProgressBar animated now={this.state.percent} />
							</div>
						</div>
					</Col>
				</Row>
			</div>
		)
	}
}